module.exports = __webpack_public_path__ + "img/blufi_hero_card.a38fdfc6.png";